<template>
  <div class="">
    <div class="quotation-info-block row">
      <!--    <PageTitle class="page-title">Запит </PageTitle>-->
      <div class="quotation-info col-lg-8">
        <div class="row">
          <div class="col-12">
            <div class="container block-box info-border pt-4 pb-4">
              <div class="row">
                <div class="col-lg-12 mb-3">
                  <div class="info-block-title">
                    Деталі
                  </div>
                </div>
              </div>

              <div class="row">
                <div v-if="fields.length && formValues[field.id]" v-for="field in getMainFields" :key="field.id" class="col-lg-6">
                  <div class="form-group">
                    <div class="info-field-name">{{ field.label }}</div>
                    <div class="info-field-value">
                      {{ formValues[field.id] }}
                    </div>
                  </div>
                </div>
              </div>

              <hr>

              <div class="row" v-if="Object.keys(existingFiles).length">
                <div class="col-lg-12 ">
                  <div class="sp-label">
                    Файли
                  </div>
                  <div class="col-lg-12 info-border">
                    <div class="row">
                      <div v-if="hasFileFields && existingFiles[field.id]" v-for="field in getFileFields" :key="field.id" class="col-lg-6">

                        <div class="form-group">
                          <div class="info-field-value file-value">
                            <div class="existing-file d-flex align-center">
                              <SmartLink :url="existingFiles[field.id].startsWith('http') ? existingFiles[field.id] : (url + 'storage/' + existingFiles[field.id])" target="_blank" class="file-link">
                                <ClipIcon
                                  class="date-input__icon"
                                  :color="'#24282c'"
                                />
                                {{ field.label }}
                              </SmartLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr v-if="company || comment">

              <div class="row" v-if="company">
                <div  class="col-lg-12">
                  <div v-if="company" class="form-group">
                    <div class="info-field-name">Бажана СК</div>
                    <div class="info-field-value">
                      {{ getCompany() }}
                    </div>
                  </div>
                  <div v-if="comment" class="form-group">
                    <div class="info-field-name">Коментар</div>
                    <div class="info-field-value">
                      {{ comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="quotation-info col-lg-4">
        <div class="row">
          <div class="col-12">
            <div class="container block-box info-border pt-4">
              <div class="row">
                <div class="col-lg-12 mb-3">
                  <div class="info-block-title">
                    Чат
                  </div>
                </div>
              </div>
              <div class="row">
                <quotation-chat ref="quotationChat" :quotation-id="quotationRequestId"></quotation-chat>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="quotation-info quotation-propositions col-lg-8">
        <div class="row">
          <div class="col-12">
            <div class="container block-box info-border pt-4">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="info-block-title">
                    Пропозиції
                  </div>
                </div>
              </div>
              <div class="row">
                <div v-for="proposition in quotationPropositions" :key="proposition.id" class="proposition-item col-lg-12">
                  <div class="proposition-item__content">
                    <div class="proposition-item__name">{{ proposition.name }}</div>
                    <div :class="['proposition-item__details_info']">
                      <div :class="['details-text', { 'collapsed': !isFull }]">{{ proposition.details_info }}</div>
                      <button @click="isFull = !isFull">
                        {{ isFull ? 'Свернуть' : 'Развернуть' }}
                      </button>
                    </div>
                    <div class="proposition-item__files_block" v-if="proposition.files && proposition.files.length">
                      <div v-for="propFile in proposition.files" :key="propFile.id" class="proposition-file-item">
                        <div class="existing-file d-flex align-center">
                          <SmartLink :url="propFile.fileUrl || (url + 'storage/' + propFile.path)" target="_blank" class="proposition-file-link">
                            <ClipIcon :color="'#24282c'"/>
                            {{ propFile.original_name }}
                          </SmartLink>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="proposition-item__select">
                    <el-button
                      type="primary"
                      :class="['btn-outline-blue', 'select-proposition-btn', { 'selected': isPropositionSelected(proposition.id, proposition) }]"
                      @click="selectProposition(proposition.id, proposition)">
                      Обрати для укладання
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <quotation-proposition-dialog ref="quotationPropositionDialog" :quotation="selectedQuotation" :quotationData="quotationData" :dialog-visible.sync="showQuotationDialog"/>
  </div>
</template>


<script>
import { PageTitle } from '@/shared/ui/page-title';
import axios from 'axios';
import {
  getQuotationTypes,
  getQuotation,
  getQuotationRequest,
  getPropositionsByRequest,
  selectProposition
} from "@/api/quotation";
import Multiselect from 'vue-multiselect';
import FileInput from '@/components/app/forms/FileInput.vue';
import FileInputMultiple from "@/components/app/quotation/components/FileInput.vue";
import Link from "../../../mixin/link";
import { ClipIcon, TrashIcon, DownloadIcon } from '@/shared/ui/icons';
import DeleteButton from "@/components/ui/DeleteButton.vue";
import { SmartLink } from '@/shared/ui/link';
import QuotationChat from "@/components/app/quotation/QuotationChat.vue";
import QuotationPropositionDialog from "@/components/app/quotation/QuotationPropositionDialog.vue";

export default {
  components: {
    PageTitle,
    SmartLink ,
    Link,
    ClipIcon,
    TrashIcon,
    DownloadIcon,
    DeleteButton,
    Multiselect,
    FileInput,
    FileInputMultiple,
    QuotationChat,
    QuotationPropositionDialog
  },
  data() {
    return {
      quotationTypes: [],
      quotationPropositions: [],
      selectedQuotation: null,
      selectedPropositionId: null,
      fields: [],
      formValues: {},
      allowedCompanies: ['Оранта', 'Інго', 'Евроінс'],
      quotationData: null,
      submitForm: false,
      showQuotationDialog: false,
      draftId: null,
      comment: null,
      company: null,
      desiredCommission: null,
      existingFiles: {},
      chatFiles: null,
      quotationRequestId: null,
      newMessage: null,
      messages: [],
      lastMessageId: null,
      pollInterval: null,
      isFull: false,
    };
  },

  computed: {
    getMainFields() {
      return this.fields.filter(i => i.type !== 'file');
    },
    getFileFields() {
      return this.fields.filter(i => i.type === 'file');
    },
    hasFileFields() {
      return this.getFileFields.length > 0;
    }
  },

  created() {
    if (this.$route.params.id) {
      this.quotationRequestId = this.$route.params.id;
    }
  },

  async mounted() {
    await this.loadQuotationTypes();
    if (this.$route.params.id) {
      await this.loadInfo(this.$route.params.id);
      await this.loadPropositions();
    }
  },

  watch: {
  },

  methods: {
    getPlaceholder(field) {
      return 'Введіть ' + (field.label ? field.label.toLowerCase() : '');
    },
    getCompany() {
      if (this.company && Array.isArray(this.company)) {
        return this.company.join(', ');
      } else {
        return this.company;
      }
    },
    selectItem(item) {

    },
    async loadQuotationTypes() {
      const { data } = await getQuotationTypes();
      this.quotationTypes = data;
    },
    async loadPropositions() {
      const { data } = await getPropositionsByRequest(this.quotationRequestId);
      this.quotationPropositions = data;
      const selectedProposition = this.quotationPropositions.find(i => i.statusId === 1);
      if (selectedProposition && selectedProposition.id) {
        this.selectedPropositionId = selectedProposition.id;
      }
    },
    async loadProduct(product, id) {
      const productCode = product.code ? product.code : '';
      const { data } = await getQuotation(id, productCode);
      this.submitForm = false;
      this.fields = data.fields;
      this.formValues = {};

      this.fields.forEach(field => {
        this.$set(this.formValues, field.id, null);
      });
    },
    async initDefaultQuotation() {
      if (!this.quotationTypes || !this.quotationTypes.length) {
        return;
      }

      let defaultProduct = this.quotationTypes.find(p => p.code === 'kasko');

      if (!defaultProduct) {
        defaultProduct = this.quotationTypes[0];
      }

      this.selectedQuotation = defaultProduct;
      await this.loadProduct(defaultProduct, defaultProduct.id);
    },
    async loadInfo(id) {

      this.quotationRequestId = id;
      const response = await getQuotationRequest(id);
      const quotationRequest = response.data.request;
      const quotationRequestValues = response.data.values;
      this.$emit('change-title-data', id, quotationRequest);
      const quotationProduct = this.quotationTypes.find(quo => quo.id == quotationRequest.quotationTypeId)

      this.selectedQuotation = quotationProduct;
      await this.loadProduct(quotationProduct, quotationProduct.id);

      Object.keys(quotationRequestValues).forEach(fieldId => {
        if (this.formValues.hasOwnProperty(fieldId)) {

          const field = this.fields.find(f => f.id == fieldId)

          if (!field) return

          if (field.type === 'file') {
            this.$set(this.existingFiles, fieldId, quotationRequest.fileUrls && quotationRequest.fileUrls[fieldId] ? quotationRequest.fileUrls[fieldId] : quotationRequestValues[fieldId])
          } else {
            this.$set(this.formValues, fieldId, quotationRequestValues[fieldId])
          }
        }
      });

      // this.formValues = {
      //   ...this.formValues,
      //   ...quotationRequestValues
      // }

      this.draftId = quotationRequest.id;
      this.company = quotationRequest.company;
      this.comment = quotationRequest.comment;
      this.isDraftMode = true;
    },
    replaceFile(file, fieldId) {
      this.$set(this.chatFiles, fieldId, file)

      if (this.existingFiles[fieldId]) {
        this.$delete(this.existingFiles, fieldId)
      }
    },
    isPropositionSelected(propositionId, propositionRow) {
     return propositionRow.statusId === 1;
    },
    selectProposition(propositionId, propositionRow) {

      if (!this.selectedPropositionId && this.selectedPropositionId !== 0) {
        selectProposition(propositionId).then(({ data }) => {
          this.$refs.quotationPropositionDialog.show(propositionId, propositionRow, this.selectedPropositionId);
          this.selectedPropositionId = propositionId;
          propositionRow.statusId = 1;
        }).catch(err => {
          console.log(err);
        });
      } else {
        this.$refs.quotationPropositionDialog.show(propositionId, propositionRow, this.selectedPropositionId);
      }
    }

  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import "../styles/quotations";
</style>
